<template>
    <div class="card">
        <div class="card-content">
            <div class="empresa-container">
                <div class="empresa-container__image">
                    <upload-image v-model="form.img">
                        <img
                            class="t-image"
                            v-if="form.img"
                            :src="form.img"
                            :alt="form.razon_social"
                        />
                    </upload-image>
                </div>
                <div class="empresa-container__form is-relative">
                    <b-loading
                        :is-full-page="false"
                        v-model="initLoading"
                    ></b-loading>
                    <form @submit.prevent="handleActualizarEmpresa">
                        <b-field
                            label="Razón Social"
                            label-position="on-border"
                        >
                            <b-input
                                v-model="form.razon_social"
                                name="razon_social"
                                required
                            ></b-input>
                        </b-field>
                        <b-field label="RUC" label-position="on-border">
                            <b-input
                                v-model="form.ruc"
                                name="ruc"
                                required
                                disabled
                            ></b-input>
                        </b-field>
                        <b-field label="Pais" label-position="on-border">
                            <b-select v-model="form.pais_id" required expanded>
                                <option
                                    v-for="pais of paises"
                                    :key="pais.id"
                                    :value="pais.id"
                                >
                                    {{ pais.descripcion }}
                                </option>
                            </b-select>
                        </b-field>
                        <b-field
                            label="Dirección (opcional)"
                            label-position="on-border"
                        >
                            <b-input
                                v-model="form.direccion"
                                name="direccion"
                            ></b-input>
                        </b-field>
                        <b-field
                            label="Nombre Alternativo (opcional)"
                            label-position="on-border"
                        >
                            <b-input
                                v-model="form.nombre_corto"
                                name="nombre_corto"
                            ></b-input>
                        </b-field>
                        <br />
                        <button
                            class="button is-block is-fullwidth is-primary"
                            :class="{ 'is-loading': loading }"
                            :disabled="loading || !enableForm"
                            type="submit"
                        >
                            Guardar
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BASE_URL, API_URL } from '@/config';
import UploadImage from '@/components/shared/UploadImage.vue';
import AutocompletePaises from '@/components/shared/FormControls/AutocompletePaises.vue';
import Message from '@/utils/Message';

export default {
    components: {
        UploadImage,
        AutocompletePaises,
    },
    data() {
        return {
            base_url: BASE_URL,
            initLoading: false,
            loading: false,
            selected: null,
            params: {},
            url: `${API_URL}/empresas/image`,
            form: {
                razon_social: '',
                ruc: '',
                pais_id: '',
                direccion: '',
                nombre_corto: '',
                img: '',
            },
        };
    },
    computed: {
        perfil() {
            return this.$store.state.me.perfil;
        },
        fotoEmpresa() {
            return this.$store.state.me.perfil.trabajador.empresa.ruta_imagen
                ? `${BASE_URL}/${this.$store.state.me.perfil.trabajador.empresa.ruta_imagen}`
                : null;
        },
        paises() {
            return this.$store.state.paises.data;
        },
        filteredDataObj() {
            return this.paises.filter((pais) => {
                return (
                    pais
                        .toString()
                        .toLowerCase()
                        .indexOf(this.form.pais?.toLowerCase()) >= 0
                );
            });
        },
        enableForm() {
            return (
                this.form.razon_social !== '' &&
                this.form.ruc !== '' &&
                this.form.pais !== ''
            );
        },
    },
    async mounted() {
        this.initLoading = true;
        const { data } = await this.$store.dispatch('me/empresa');
        await this.fetchPaises();
        this.loadData(data);
        this.initLoading = false;
    },
    methods: {
        async fetchPaises() {
            await this.$store.dispatch('paises/get');
        },
        loadData(empresa) {
            this.form.razon_social = empresa.razon_social;
            this.form.ruc = empresa.ruc;
            this.form.pais_id = empresa.pais_id;
            this.form.direccion = empresa.direccion;
            this.form.nombre_corto = empresa.nombre_corto;
            this.form.img = 'data:image/jpg;base64,' + empresa.img;
        },
        async handleActualizarEmpresa() {
            this.loading = true;
            try {
                const res = await this.$store.dispatch(
                    'empresas/update',
                    this.form
                );
                Message.showSuccessMessage(this, res.message);
            } catch (err) {
                Message.showErrorMessage(this, err.message);
            } finally {
                this.loading = false;
                await this.$store.dispatch('me/get');
            }
        },
        setIsModalSubirImagen(value) {
            this.$store.dispatch('ui/setIsModalSubirImagen', value);
        },
    },
};
</script>

<style lang="scss" scoped>
.empresa-container {
    display: flex;
    align-items: center;
    width: 100%;

    & > .empresa-container__image {
        display: flex;
        align-items: center;
        padding: 1rem;
        flex-basis: 350px;
    }

    & > .empresa-container__form {
        width: 100%;
        padding: 1rem;
    }
}

@media screen and (max-width: 700px) {
    .empresa-container {
        flex-direction: column;

        & > .empresa-container__image {
            padding: 0rem 0rem 1rem 0rem;
            flex-basis: 0px;
        }

        & > .empresa-container__form {
            padding: 0rem;
        }
    }
}
</style>
